<template>
    <div>
        <CodeEditor v-model="constraints.custom_data.dataJson.template" :libs="libs" label="Template" :label-cols="3" />
    </div>
</template>
<script>
export default {
    components: {
        CodeEditor: () => import("@/components/form/Editor/Code")
    },
    props: {
        value: {
            type: Object | Array,
            default: function() {
                return null
            }
        }
    },
    data: function() {
        return {
            showEditor: false
        }
    },
    computed: {
        constraints: {
            get() {
                let base = this.value
                let {custom_data = {}} = base
                let {dataJson} = custom_data

                if (!dataJson) {
                    custom_data.dataJson = {
                        template: ""
                    }
                }

                console.log(base)

                return base;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        libs() {
            return  [
                {
                    name: "bootstrap-vue",
                    varName: "*",
                    docs: "https://bootstrap-vue.org/docs/components"
                },
            ]
        }
    },
    methods: {
        
    }
    
}
</script>